var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAntiguaAndBarbuda(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m7 11.01 4.08-.78L7.6 7.95l4.06.84-2.33-3.43 3.44 2.33-.84-4.07 2.28 3.47.78-4.08.78 4.08 2.28-3.47-.84 4.07 3.44-2.33-2.33 3.43 4.06-.84-3.47 2.28 4.08.78z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0072c6",
    d: "M0 11h30v5H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9 15h12v9H9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "M0 24V0l15 24zm30 0H15L30 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAntiguaAndBarbuda);
export default __webpack_public_path__ + "static/media/antigua-and-barbuda.d5fc381e7e0bf94132436420d4d95eee.svg";
export { ForwardRef as ReactComponent };